import { render, staticRenderFns } from "./pharmacies.vue?vue&type=template&id=96337ebc&"
import script from "./pharmacies.vue?vue&type=script&lang=js&"
export * from "./pharmacies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports